<template>
  <div id="app">
    <router-view/>
    <CoolMSketelon :show="pageLoading" fixCenter/>
  </div>
</template>

<script>
import { env, ILocalStorage, webSDK } from '@utils';
import { autoLaunch } from '@igetcool/base-components';
import { getGoodDetail } from '@/api/goods';
import { CoolMSketelon } from '@igetcool/cool-mobile-ui';

export default {
  components: {
    CoolMSketelon
  },
  provide() {
    return {
      // 是否显示商品划线价格 0: 否（不显示）， 1: 是（显示）
      showLinePrice: () => this.isShowLinePrice
    };
  },
  name: 'App',
  data() {
    return {
      hasSet: false,
      course: null,
      isShowLinePrice: 0,
      pageLoading: false
    };
  },
  methods: {
    shareConfigHandle(course, itemid) {
      let shareConfig;
      const config = JSON.parse(ILocalStorage('shareConfig'));
      if (config && config.itemid === this.itemid) {
        shareConfig = ILocalStorage('shareConfig');
      } else {
        let query = '?';
        for (let key in this.$route.query) {
          query += `${key}=${this.$route.query[key]}&`;
        }
        query = query.substr(0, query.length - 1);
        if (course.basicAndGuideShareResDTO) {
          shareConfig = {
            title: data.basicAndGuideShareResDTO.shareTitle,
            link: `${location.origin}/mall/course${query}`,
            desc: data.basicAndGuideShareResDTO.shareDescribe,
            imgUrl: data.basicAndGuideShareResDTO.shareImageUrl
          };
        } else {
          shareConfig = {
            title: `【少年得到】「${course.name}」点击立即报名`,
            link: `${location.origin}/mall/course${query}`,
            desc: `点击立即报名「${course.name}」`,
            imgUrl: course.coverImg
          };
        }
        ILocalStorage('shareConfig', JSON.stringify({
          itemid: itemid,
          ...shareConfig
        }));
      }
      return shareConfig;
    },
    weChatShareConfig(shareConfig) {
      webSDK.setShare({
        title: shareConfig.title,
        link: shareConfig.link,
        desc: shareConfig.desc,
        imgUrl: shareConfig.imgUrl
      });
    }
  },
  mounted() {
    autoLaunch.init();
  },
  watch: {
    async $route(a) {
      if (a.name === 'courseItem') { return false }
      const { itemid, diffSkuId } = a.query;
      let config = JSON.parse(ILocalStorage('shareConfig'));
      const name = a.name;
      const exclude = ['courserVersion1.0', 'OrderVersion1.0', 'groupBuySuccess', 'groupBuyShare', 'logisticsDetail', 'cardPackage'];
      if (env.isWeChat && itemid && !exclude.includes(name)) {
        try {
          // diffSkuId 补差价标识，由于用的详情页不一样 项目启动就直接请求这个商品详情会报错
          if ((!config || config.itemid !== itemid) && !diffSkuId) {
            const { data } = await getGoodDetail({ infoId: itemid });
            config = data && this.shareConfigHandle(data, itemid);
          }
          this.weChatShareConfig(config);
        } catch (error) {}
      }
    },
  },
  created() {

  }
};
</script>
